<template>
  <div>
    <form>
      <v-text-field
        v-model="item.comment"
        label="Dôvod vytvorenia"
        readonly
      />
      <v-text-field
        v-model="item.created_at"
        label="Dátum vytvorenia"
        readonly
      />
      <v-text-field
        v-model="item.updated_at"
        label="Dátum poslednej úpravy"
        readonly
      />
      <v-text-field
        v-model="item.prisoner_full.base_number"
        label="Základné číslo"
        readonly
      />
      <v-text-field
        v-model="item.institution_full.name"
        label="Ústav"
        readonly
      />
      <v-text-field
        v-model="item.prisoner_full.birth_date"
        label="Dátum narodenia"
        readonly
      />
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();

export default {
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,

    item: {
      prisoner_full: {
        comment: "",
        base_number: "",
        birth_date: ""
      },
      institution_full: {
        name: ""
      }
    }
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    getItem() {
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.item = response;
      });
    }
  }
};
</script>